<template>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <circle cx="7" cy="12" r="7" fill="#EA001B"/>
            <circle cx="17" cy="12" r="7" fill="#FFA200" fill-opacity=".8"/>
        </g>
    </svg>
</template>
